/*
 * <go-atc-button> - direct add-to-cart button for the go- landing page
 * sections (rendered by snippets/go-atc-button.liquid).
 *
 * Adds ONE unit of the variant in data-variant-id via window.fetch on
 * FoxTheme.routes.cart_add_url, exactly like the theme's own product forms, so
 * the BOGOS/Rebuy fetch-interceptor chain fires: the Rebuy Smart Cart drawer
 * opens off the /cart/add interception and the header cart bubble updates via
 * the FoxTheme pubsub cartUpdate event.
 *
 * Non-drawer cart contexts (cart page / cartType != 'drawer') fall back to a
 * classic form POST, mirroring go-products-bundle.js. theme.js stays untouched.
 */
if (!customElements.get('go-atc-button')) {
  class GoAtcButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.go-atc__btn');
      this.errorEl = this.querySelector('.go-atc__error');
      this.cartDrawerElement = document.querySelector('cart-drawer');

      if (this.button && !this.button.disabled) {
        this.button.addEventListener('click', this.handleClick.bind(this));
      }
    }

    handleClick(event) {
      event.preventDefault();
      if (this.button.classList.contains('btn--loading')) return;

      const variantId = parseInt(this.button.dataset.variantId, 10);
      if (!variantId) return;

      const items = { items: [{ id: variantId, quantity: 1 }] };

      // Full page-load contexts: classic form POST, the redirect renders /cart.
      if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType !== 'drawer') {
        FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { ...items } });
        return;
      }

      this.showError();
      this.toggleLoading(true);

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const body = JSON.stringify({
        ...items,
        sections: sectionsToBundle,
        section_url: window.location.pathname,
      });

      fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
        .then((response) => response.json())
        .then(async (parsedState) => {
          if (parsedState.status) {
            this.showError(parsedState.description || parsedState.message);
            return;
          }

          const cartJson = await (
            await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
          ).json();
          cartJson['sections'] = parsedState['sections'];

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));
          this.cartDrawerElement && this.cartDrawerElement.show(this.button);
        })
        .catch((error) => {
          console.error('go-atc-button:', error);
          this.showError(window.cartStrings && window.cartStrings.error);
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    }

    toggleLoading(loading) {
      this.button.classList.toggle('btn--loading', loading);
      this.button.toggleAttribute('aria-busy', loading);
    }

    showError(message = false) {
      if (!this.errorEl) return;
      this.errorEl.classList.toggle('hidden', !message);
      this.errorEl.textContent = message || '';
    }
  }

  customElements.define('go-atc-button', GoAtcButton);
}
